import { useTranslation } from 'react-i18next';
import { SelectListType } from '@aqarmap/aqarmap-ui/dist/types/components/SelectGroup/types';
import { dateRangeValuesType } from '~myAccount/pages/Wallet/types';

export default function useFilterByDate() {
  const labelClassName = 'text-body_2 text-gray__dark_2';

  const { t } = useTranslation('app');
  const today = new Date().toISOString().slice(0, 10);
  const dateRangeValues: dateRangeValuesType = {
    allTime: { date_from: '', date_to: '' },
    lastDay: {
      date_from: new Date(new Date().setDate(new Date().getDate() - 1))
        .toISOString()
        .split('T')[0],
      date_to: new Date().toISOString().split('T')[0],
    },
    lastWeek: {
      date_from: new Date(new Date().setDate(new Date().getDate() - 7))
        .toISOString()
        .split('T')[0],
      date_to: new Date().toISOString().split('T')[0],
    },
    lastMonth: {
      date_from: new Date(new Date().setDate(new Date().getDate() - 30))
        .toISOString()
        .split('T')[0],
      date_to: new Date().toISOString().split('T')[0],
    },
    customDate: { date_from: today, date_to: today },
  };

  const options: SelectListType[] = [
    {
      field: {
        value: 'allTime',
      },
      label: { text: t('allTime'), className: labelClassName },
    },
    {
      field: {
        value: 'lastDay',
      },
      label: { text: t('lastDay'), className: labelClassName },
    },
    {
      field: {
        value: 'lastWeek',
      },
      label: { text: t('lastWeek'), className: labelClassName },
    },
    {
      field: {
        value: 'lastMonth',
      },
      label: { text: t('lastMonth'), className: labelClassName },
    },
    {
      field: {
        value: 'customDate',
      },
      label: { text: t('customDate'), className: labelClassName },
    },
  ];

  return {
    options,
    dateRangeValues,
  };
}
